import React, { useState, useEffect } from 'react'
import { Form, Row, Col, Select, Input, Button } from 'antd'
import { toast } from 'react-toastify'
import apiRequest from '../../hooks/ApiRequest'

const { Option } = Select

const ClaimLimitForm = ({ form, brokerID, modalVisible, onSuccess }) => {
  const { getFieldDecorator, setFieldsValue, resetFields, getFieldValue } = form
  const [roles, setRoles] = useState([])
  const [loading, setLoading] = useState(false)
  const [claimManager, setClaimManager] = useState(false)
const UserId = localStorage.getItem('loggedInUserID')
  const fetchRoles = async () => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/child-roles`,
        'GET',
      )
      const fetchClaimManager = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/get-users-by-role`,
        'GET',
      )
      if (fetchClaimManager?.success) {
        setClaimManager(fetchClaimManager?.data)
      }
      if (res.success) {
        let filteredRoles = res?.data.filter(d => d.displayName != null)

        setRoles(filteredRoles)
      } else {
        toast.error('Failed to fetch roles')
      }
    } catch (error) {
      toast.error('Error loading roles')
    }
  }

  const fetchClaimLimitById = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Settings/${id}`,
        'GET',
      )
      if (res.success) {
        const data = res.data
        setFieldsValue({
          roleId: data.roleId,
          lowerLimit: data.lowerLimit,
          upperLimit: data.upperLimit,
          multiEscId: data.multiEscId,
        })
      } else {
        toast.error('Failed to fetch claim limit details')
      }
    } catch (err) {
      toast.error('Error loading claim limit')
    }
  }

  useEffect(() => {
    fetchRoles()
    if (brokerID) {
      fetchClaimLimitById(brokerID)
    } else {
      resetFields()
    }
  }, [brokerID, modalVisible])

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)

      const selectedRole = roles.find(r => r.id === values.roleId)
      const payload = {
        id: brokerID || 0,
        roleId: values.roleId,
        role: selectedRole?.roleName || '',
        lowerLimit: Number(values.lowerLimit),
        upperLimit: Number(values.upperLimit),
        multiEscId: values?.multiEscId,
        insurerId: UserId,
      }

      const url = brokerID
        ? `${process.env.REACT_APP_BASE_URL_AUTH}/api/Settings/save`
        : `${process.env.REACT_APP_BASE_URL_AUTH}/api/Settings/save`
      // : `https://localhost:44358/api/Settings/save`

      try {
        const res = await apiRequest(url, 'POST', [payload])
        if (res.success) {
          toast.success(
            brokerID
              ? 'Claim limit updated successfully'
              : 'Claim limit set successfully',
          )
          if (onSuccess) onSuccess()
        } else {
          toast.error(res.message || 'Something went wrong')
        }
      } catch (err) {
        toast.error('Request failed')
      } finally {
        setLoading(false)
      }
    })
  }


  const validateLowerLimit = (_, value, callback) => {
    const upperLimit = getFieldValue('upperLimit')
    if (upperLimit && Number(value) > Number(upperLimit)) {
      callback('Lower Limit must be less than or equal to Upper Limit.')
    } else {
      callback()
    }
  }

  const validateUpperLimit = (_, value, callback) => {
    const lowerLimit = getFieldValue('lowerLimit')
    if (lowerLimit && Number(value) < Number(lowerLimit)) {
      callback('Upper Limit must be greater than or equal to Lower Limit.')
    } else {
      callback()
    }
  }

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Row gutter={16}>
        <Col md={12}>
          <Form.Item label="Escalator 1">
            {getFieldDecorator('roleId', {
              rules: [{ required: true, message: 'Please select Escalator' }],
            })(
              <Select placeholder="Select Escalator 1" loading={loading}>
                {roles.map(role => (
                  <Option key={role.id} value={role.id}>
                  {role.displayName}
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Col>
        <Col md={12}>
          <Form.Item label="Escalator 2">
            {getFieldDecorator('multiEscId')(
              <Select placeholder="Select Escalator 2" loading={loading}>
                {roles.map(role => (
                  <Option key={role.id} value={role.id}>
                    {role.displayName}
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
        </Col>

        <Col md={12}>
          <Form.Item label="Lower Limit">
            {getFieldDecorator('lowerLimit', {
              rules: [
                { required: true, message: 'Please input lower limit!' },
                {
                  pattern: /^\d+$/,
                  message: 'Limit must contain only digits',
                },
                { validator: validateLowerLimit },
              ],
            })(
              <Input
                placeholder="Enter lower limit"
                type="text"
                maxLength={10}
              />,
            )}
          </Form.Item>

        </Col>

        <Col md={12}>
          <Form.Item label="Upper Limit">
            {getFieldDecorator('upperLimit', {
              rules: [
                { required: true, message: 'Please input upper limit!' },
                {
                  pattern: /^\d+$/,
                  message: 'Limit must contain only digits',
                },
                { validator: validateUpperLimit },
              ],
            })(
              <Input
                placeholder="Enter upper limit"
                type="text"
                maxLength={10}
              />,
            )}
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {brokerID ? 'Update Claim Limit' : 'Set Claim Limit'}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default Form.create({ name: 'claim_limit_form' })(ClaimLimitForm)